/* eslint-disable @typescript-eslint/no-explicit-any */
import { Vue, Component } from 'vue-property-decorator';
@Component
export default class UpdateMixIn extends Vue {
  refreshing = false;
  registration: any = null;
  updateExists = false;

  created() {
    // Listen for our custom event from the SW registration
    document.addEventListener('swUpdated', this.updateAvailable, {
      once: true
    });

    // Prevent multiple refreshes
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (this.refreshing) return;
      this.refreshing = true;
      // Here the actual reload of the page occurs
      //localStorage.removeItem('vuex');
      window.location.reload();
    });
    console.log('Added Update Listner');
  }

  // Store the SW registration so we can send it a message
  // We use `updateExists` to control whatever alert, toast, dialog, etc we want to use
  // To alert the user there is an update they need to refresh for
  updateAvailable(event: any) {
    this.registration = event.detail;
    this.updateExists = true;
  }

  // Called when the user accepts the update
  refreshApp() {
    if (this.registration == null) return;
    this.updateExists = false;
    // Make sure we only send a 'skip waiting' message if the SW is waiting
    if (!this.registration || !this.registration.waiting) return;
    // send message to SW to skip the waiting and activate the new SW
    //localStorage.removeItem('vuex');
    const version = process.env.VUE_APP_VERSION;
    const major = version?.split('.')[0];
    console.info(`Checking Old Version Stores: V${version}`);
    for (const key in localStorage) {
      if (key.startsWith('vuex') && key != `vuex_v${major}`) {
        console.info(`Removing Old Store Key ${key}`);
        localStorage.removeItem(key);
      }
    }
    this.registration.waiting.postMessage({ type: 'SKIP_WAITING' });
  }
}
